import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { globalVars } from "../../App";
import { myGlobals } from "../../Utils";

class SepaPaymentDIPage extends React.Component {
  constructor(props) {
    super(props);
    this.configs = JSON.parse(globalVars.sepaDIPageConfigs);
    this.formRef = React.createRef();
  }
  insertInputs = () => {
    const keys = Object.keys(this.configs);
    let inputs = [];
    for (let i = 0; i < keys.length; ++i) {
      inputs.push(
        <input
          key={keys[i]}
          type="hidden"
          name={keys[i]}
          value={this.configs[keys[i]]}
        />
      );
    }
    return inputs;
  };
  createForm = () => {
    let action = this.configs.EIPP_DI;
    //action = action.substring(0,action.lastIndexOf("/"));
    //action+='/v2/checkOut.do';
    console.log(action);
    let heightIFrame = myGlobals.currentTheme === "trifectaTheme.css" ? 100 : 70;
    return (
      <Row>
        <Col className="sepa-di-col" sm={12}>
          <form
            ref={this.formRef}
            id="moodleform"
            target="myiframe"
            method="post"
            action={action}
          >
            {/* <input type="hidden" name="CLIENT_SYSTEM_ID" value={this.configs.CLIENT_SYSTEM_ID}/>
                              <input type="hidden" name="REQUEST_ID" value={this.configs.REQUEST_ID}/>
                              <input type="hidden" name="IS_MULTI_TOKEN" value={this.configs.IS_MULTI_TOKEN} />
                              <input type="hidden" name="LANGUAGE_CODE" value={this.configs.LANGUAGE_CODE} />
                              <input type="hidden" name="PROCESSOR_MERCHANT_VALUES" value={this.configs.PROCESSOR_MERCHANT_VALUES} />
                              <input type="hidden" name="IS_PRE_POPULATE_DI" value={this.configs.IS_PRE_POPULATE_DI} />
                              <input type="hidden" name="IS_PRE_POPULATE_DI" value={this.configs.IS_PRE_POPULATE_DI} />
                              <input type="hidden" name="CALLING_APP" value={this.configs.CALLING_APP} />
                              <input type="hidden" name="REQUESTOR" value={this.configs.REQUESTOR} />
                              <input type="hidden" name="BILL_TO_AVSCHECK_REQUIRED" value={this.configs.BILL_TO_AVSCHECK_REQUIRED} />
                              <input type="hidden" name="BILL_TO_FIRST_NAME" value={this.configs.BILL_TO_FIRST_NAME} />
                              <input type="hidden" name="REFERENCE_NUMBER" value={this.configs.REFERENCE_NUMBER} />
                              <input type="hidden" name="DATA_LEVEL" value={this.configs.DATA_LEVEL} />
                              <input type="hidden" name="TRANSACTION_TYPE" value={this.configs.TRANSACTION_TYPE} />
                              <input type="hidden" name="PK_EIPP_PAYMENT_CC_ID" value={this.configs.PK_EIPP_PAYMENT_CC_ID} />
                              <input type="hidden" name="POST_BACK_URL" value={"https://gokuafrica.000webhostapp.com/?token=lol"} /> */}
            {this.insertInputs()}
          </form>
          <iframe
            id="myiframe"
            name="myiframe"
            width="100%"
            height={(heightIFrame / 100) * window.screen.height}
            frameBorder="0"
          ></iframe>
        </Col>
      </Row>
    );
  };
  render() {
    return this.createForm();
  }
  componentDidMount() {
    this.formRef.current.submit();
  }
}

export default SepaPaymentDIPage;
